import { AppService } from './../../../../shared/services/app.service';
import { Component } from '@angular/core';
import { WebappService } from '../../../../shared/services/webapp.service';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'mobo-restaurant-list',
  templateUrl: './restaurant-list.component.html',
  styles: [],
})
export class RestaurantListComponent {
  public baseUrl = environment.baseUrl;
  public defaultImg = environment.defaultImg;
  constructor(
    public appService: AppService,
    public webappService: WebappService,
    public router: Router
  ) {}

  public redirectToRestaurant(restaurantSlug: string) {
    this.router.navigate(['/restaurante', restaurantSlug]);
  }
}
